(function tpTableOptionsCapital() {
  const isCompExists = GlobalSite.checkDependency('GlobalSite.isCompExists');
  const compName = 'tp_table-options-capital';
  const logFactory = GlobalSite.checkDependency('GlobalSite.logFactory');
  const Log = logFactory(`${compName}.js`);

  if (!isCompExists(compName, Log)) {
    return;
  }

  const accessibleValuesList = [2000, 3000, 4000, 5000, 6000, 7000, 8000];

  $(() => {
    $('.tp-table-options-capital__table-container__slider-container').slick({
      autoplay: false,
      autoplaySpeed: 1000,
      slidesToShow: 7,
      slidesToScroll: 1,
      prevArrow:
        '<button class="slick-prev" type="button"><span class="i-arrow-left-circle"></span><span class="slick-sr-only">Slide précédente</span></button>',
      nextArrow:
        '<button class="slick-next" type="button"><span class="i-arrow-right-circle"></span><span class="slick-sr-only">Slide suivante</span></button>',
      dots: true,
      arrows: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: false,
            dots: true,
            arrows: true,
          },
        },
      ],
      customPaging: (slider, i) =>
        $(
          `<button type="button"><span class="slick-dot-icon" aria-label="Slide ${
            i + 1
          }"></span><span class="slick-sr-only">Cotisations pour un capital de ${
            accessibleValuesList[i]
          } €</span></button>`,
        ),
    });
  });
})();
